/**
 * Incentive screens present their Invoice entities as Rebates. The fields below are declared on the
 * shared Inv/InvLine/Claim/ClaimLine bases that Medicaid and MCO also extend, where "Invoice" is the
 * correct term, so the labels are overridden per view rather than on the annotations.
 */
const fieldToDisplayName = {
  invRxs: 'Rebate Rxs',
  invUnits: 'Rebate Units',
  invAmt: 'Rebate Amount',
  invQty: 'Rebate Quantity',
  extInvAmt: 'External Rebate Amount',
  incrInvAmt: 'Incremental Rebate Amount',
  incrInvUnits: 'Incremental Rebate Units',
  latestInvDate: 'Latest Rebate Date',
};

export const augInctvFieldDefs = (fieldToFieldDef) => {
  Object.entries(fieldToDisplayName).forEach(([field, displayName]) => {
    if (fieldToFieldDef[field]) {
      fieldToFieldDef[field].displayName = displayName;
    }
  });
};
